import React from 'react';
import DeviationLink from '../../../Duperbrowse/DeviationLink';
var ShopCardLink = function (_a) {
    var className = _a.className, deviation = _a.deviation, children = _a.children;
    return (React.createElement(DeviationLink, { className: className, deviation: deviation }, children));
};
ShopCardLink.displayName = 'ShopCardLink';
export default ShopCardLink;
//# sourceMappingURL=ShopCardLink.js.map